<template>
    <div
        style="background: #E8F0FF;border-radius: 4px;border: 1px solid #B5C4DF;padding:20px;display: flex;align-items: flex-start;">
        <div style="flex:1;">
            <div style="color: #0F1A3A;font-size: 14px;">{{ title }}</div>
            <div style="margin-top: 15px;display: flex;align-items: center;">
                <div style="font-size: 24px;font-weight: bold;color: #0F1A3A;">{{ score }}</div>
      
            </div>
        </div>
        <div>
            <img style="width: 36px;height: 36px;" :src="imageSrc" :alt="title">
        </div>
    </div>
</template>

<script>
export default {
    props: {
      // 评分类型（不变）
      type: {
        type: String,
        required: true,
        validator: value => ['safety', 'economy', 'comfort', 'vehicleCare'].includes(value)
      },
      // 评分值：增加default: 0
      score: {
        type: Number,
        required: true,
        default: 0  // 初始默认值0（Number类型）
      },
      // 比较值：增加default: 0，同时修正传值笔误提示
      compareValue: {
        type: Number,
        required: true,
        default: 0  // 初始默认值0（Number类型）
      }
    },
    computed: {
        // 根据类型返回标题
        title() {
            const titles = {
                safety: this.$t('driver.安全性'),
                economy: this.$t('driver.经济性'),
                comfort: this.$t('driver.舒适性'),
                vehicleCare: this.$t('driver.护车性')
            }
            return titles[this.type]
        },
        // 根据类型返回对应的图片路径
        imageSrc() {
            const images = {
                safety: require('@/assets/images/ic_anquanxing@2x.png'),
                economy: require('@/assets/images/ic_jingjixing@2x.png'),
                comfort: require('@/assets/images/ic_shushixing@2x.png'),
                vehicleCare: require('@/assets/images/ic_huchexing@2x.png')
            }
            return images[this.type]
        }
    }
}
</script>
